import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

const AlbumSelectionsIcon = ({
  color = '#B5BCBD',
  className,
  width = '27',
  height = '27',
}) => (
  <svg
    viewBox="0 0 27 27"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
  >
    <g fill={color} stroke={color} fillRule="evenodd">
      <path d="M20.303 3.398a1.024 1.024 0 0 1 1.184.833l1.597 9.115a1.03 1.03 0 0 1-.832 1.19l-1.366.243V20l4.27-.756a1.03 1.03 0 0 0 .829-1.19L23.147 1.849a1.025 1.025 0 0 0-1.184-.834L5.846 3.867a1.033 1.033 0 0 0-.831 1.19l.19 1.084h2.27c.134-.302.394-.544.74-.606l12.088-2.137z" />
      <path d="M2.056 26h16.888c.581 0 1.056-.475 1.056-1.056v-9.947l-.001-6.941c0-.581-.475-1.056-1.056-1.056H2.056C1.475 7 1 7.475 1 8.056v16.89A1.06 1.06 0 0 0 2.056 26zM3.11 10.167c0-.581.475-1.056 1.056-1.056h12.666c.58 0 1.055.475 1.055 1.056v9.5c0 .58-.475 1.056-1.055 1.056H4.167c-.581 0-1.056-.475-1.056-1.056v-9.5z" />
    </g>
  </svg>
);

AlbumSelectionsIcon.propTypes = propTypes;

export default AlbumSelectionsIcon;
